package uz.ferro.erp.feature.order.ui

import HeaderTitleView
import kotlinx.coroutines.Job
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.isActive
import kotlinx.coroutines.launch
import mui.material.Box
import mui.material.Button
import mui.material.ButtonVariant
import mui.material.CircularProgress
import mui.material.Link
import mui.material.Paper
import mui.material.Size
import mui.system.sx
import react.FC
import react.create
import react.router.useLocation
import react.router.useParams
import react.useContext
import react.useEffect
import react.useState
import uz.ferro.erp.Colors
import uz.ferro.erp.NavigationContext
import uz.ferro.erp.feature.order.data.OrderRepository
import uz.ferro.erp.feature.order.model.Order
import uz.ferro.erp.feature.order.model.OrderPaymentInfo
import uz.ferro.erp.feature.order.model.OrderStatus
import uz.ferro.erp.feature.order.model.Usage
import uz.ferro.erp.feature.order.util.findData
import uz.ferro.erp.feature.product.utils.PropertyKeys
import uz.ferro.erp.manager.AuthManager
import uz.ferro.erp.navigator.NavigationPage
import uz.ferro.erp.ui.AppText
import uz.ferro.erp.ui.GenericPage
import uz.ferro.erp.ui.HorizontalLayout
import uz.ferro.erp.ui.ImageView
import uz.ferro.erp.ui.VerticalLayout
import uz.ferro.erp.ui.table.CellItem
import uz.ferro.erp.ui.table.HeaderItem
import uz.ferro.erp.ui.table.RowItem
import uz.ferro.erp.ui.table.TableView
import uz.ferro.erp.util.displayText
import uz.ferro.erp.util.formatGrouped
import uz.ferro.erp.util.localized
import uz.ferro.erp.util.orZero
import uz.ferro.erp.util.styleInMobile
import web.console.console
import web.cssom.AlignItems
import web.cssom.Auto
import web.cssom.FontStyle
import web.cssom.JustifyContent
import web.cssom.pct
import web.cssom.px
import web.cssom.vh

private val paymentInfoStatuses = listOf(
    OrderStatus.RESERVE_PENDING,
    OrderStatus.RESERVED,
    OrderStatus.PAYMENT_PENDING,
    OrderStatus.PAYMENT_FAILED
)

val OrderDetailsPage = FC {

    val pathParam = useParams()["orderId"] ?: return@FC
    val orderId = pathParam.toLongOrNull()
    var order by useState<Order>()
    var paymentInfo: OrderPaymentInfo? by useState()
    val location = useLocation()
    var loadJob: Job? = null
    var ord: Order? = null
    var usage: Usage? by useState(null)

    var pInfo: OrderPaymentInfo? = null
    val navigator = useContext(NavigationContext)
    var isLoading by useState(false)
    var showTopUp by useState(false)

    suspend fun loadData() {
        if (orderId != null) {
            isLoading = true
            try {
                ord = OrderRepository.getOrder(orderId)
                if (ord!!.status == OrderStatus.COMPLETED) {
                    val usg = OrderRepository.getUsage(orderId)
                    if (usg != null) {
                        usage = usg
                    }
//                    showTopUp = true
                }
                order = ord
            } catch (e: Exception) {
                //no-op
            }
            isLoading = false
        }

        if (ord != null && pInfo == null) {
            if (paymentInfoStatuses.contains(ord!!.status)) {
                try {
                    pInfo = OrderRepository.getPaymentInfo(ord!!.id!!)
                    paymentInfo = pInfo
                } catch (e: Exception) {
                    //no-op
                    console.error(e)
                }
            }
        }
    }

    useEffect(location) {
        console.log("useEffect location")
        if (loadJob?.isActive != true) {
            loadJob = MainScope().launch {
                while (isActive) {
                    loadData()
                    if (ord?.status == OrderStatus.COMPLETED) {
                        break
                    }

                    delay(3000)
                }
            }
        }

        cleanup {
            console.log("Clean up")
            loadJob?.cancel()
        }
    }

    GenericPage {
        if (isLoading) {
            VerticalLayout {
                sx {
                    minHeight = 300.px
                    justifyContent = JustifyContent.center
                    alignItems = AlignItems.center
                }
                CircularProgress()
            }
        } else {
            topFullWidthChildren = HeaderTitleView.create {
                this.title = "Buyurtma #${order?.id?.toString().orEmpty()}"
            }

            Box {
                sx {
                    height = 24.px
                }
            }

            VerticalLayout {
                space = 12.px

                HorizontalLayout {
                    space = 8.px
                    sx {
                        alignItems = AlignItems.end
                    }
                    AppText {
                        size = 18
                        color = Colors.textSecondary
                        text = "Mahsulot"
                    }

                    AppText {
                        size = 20
                        text = order?.product?.title.localized()
                    }
                }

                HorizontalLayout {
                    space = 8.px

                    sx {
                        alignItems = AlignItems.end
                    }

                    AppText {
                        size = 18
                        color = Colors.textSecondary
                        text = "Holati"
                    }

                    AppText {
                        size = 20
                        text = order?.status?.displayText()
                    }
                }

                if (paymentInfoStatuses.contains(order?.status)) {
                    AppText {
                        sx {
                            marginTop = 20.px
                        }
                        size = 18
                        color = Colors.textSecondary
                        text = "To'lov usullari"
                    }

                    if (paymentInfo?.paymeLink.orEmpty().isNotBlank()) {
                        Button {
                            variant = ButtonVariant.text
                            sx {
                                marginTop = 20.px
                                width = styleInMobile(100.pct, 180.px)
                            }
                            ImageView {
                                sx {
                                    width = 180.px
                                    height = Auto.auto
                                }
                                url = "/icons/payme_logo.svg"
                            }

                            onClick = {
                                navigator.openUrl(paymentInfo?.paymeLink.orEmpty())
                            }
                        }
                    }
                }

                if (order?.status == OrderStatus.COMPLETED) {
                    val properties = order?.properties.orEmpty()
                    val lpa = properties.findData(PropertyKeys.LOCAL_PROFILE_ASSISTANT)
                    val data = listOf(
                        "ICCID" to properties.findData(PropertyKeys.ICCID),
                        "SMDP Manzil" to properties.findData(PropertyKeys.SMDP_ADDRESS),
                        "Kirish nuqtasi (APN)" to properties.findData(PropertyKeys.ACCESS_POINT_NAME),
                        "Faollashtirish kodi" to properties.findData(PropertyKeys.ACTIVATION_CODE),
                    )

                    val packages = usage?.packages.orEmpty()

                    if (packages.isNotEmpty()) {
                        Paper {
                            sx {
                                borderRadius = 15.px
                                padding = 15.px
                            }

                            TableView {
                                positionAutoHeight = true
                                headers = listOf(
                                    HeaderItem("Nomi"),
                                    HeaderItem("Sana"),
                                    HeaderItem("Muddat"),
                                    HeaderItem("Umumiy MB"),
                                    HeaderItem("Foydalanilgan MB")
                                )

                                items = packages.map { pkg ->
                                    RowItem(
                                        key = pkg.productName.localized(),
                                        cells = listOf(
                                            CellItem(pkg.productName.localized()),
                                            CellItem(pkg.activationDate),
                                            CellItem(pkg.expirationDate),
                                            CellItem("${pkg.totalMb.orZero().formatGrouped()} MB"),
                                            CellItem("${pkg.usedMb.orZero().formatGrouped()} MB")
                                        )
                                    )
                                }
                            }
                        }
                    }

                    if (showTopUp) {
                        Button {
                            sx {
                                width = 100.pct
                                maxWidth = 200.px
                                borderRadius = 50.vh
                                backgroundColor = Colors.accentColor
                            }
                            size = Size.small
                            variant = ButtonVariant.contained
                            onClick = {
                                navigator.openPage(NavigationPage.TOP_UP, order?.id.toString())
                            }
                            +"To'ldirish"
                        }
                    }

                    Box {
                        sx {
                            height = 20.px
                        }
                    }

                    Paper {
                        sx {
                            borderRadius = 15.px
                            padding = 15.px
                        }

                        VerticalLayout {
                            space = 12.px

                            AppText {
                                size = 20
                                text = "Faollashtirish uchun ma'lumotlar"
                            }

                            ImageView {
                                sx {
                                    width = 240.px
                                    height = 240.px
                                }
                                url = order?.properties.findData(PropertyKeys.QR_CODE)
                            }

                            AppText {
                                size = 18
                                text = lpa
                            }

                            Box {
                                sx {
                                    height = 12.px
                                }
                            }
                            data.forEach { (title, value) ->
                                VerticalLayout {
                                    AppText {
                                        size = 18
                                        color = Colors.textSecondary
                                        text = title
                                    }

                                    AppText {
                                        size = 20
                                        text = value
                                    }
                                }
                            }
                        }
                    }
                }

                if (order?.status == OrderStatus.NEW) {
                    Box {
                        sx {
                            marginTop = 20.px
                        }
                        AppText {
                            sx {
                                fontStyle = FontStyle.italic
                            }
                            size = 18
                            text = "To'lovni amalga oshirish uchun buyurtma raqamingizni telegram orqali "
                        }



                        AppText {
                            sx {
                                marginLeft = 8.px
                            }
                            size = 18
                            text = "ga jo'nating"
                        }
                    }
                } else {
                    Box {
                        sx {
                            marginTop = 20.px
                        }

                        AppText {
                            sx {
                                fontStyle = FontStyle.italic
                            }
                            size = 18
                            text = "Qo'shimcha ma'lumotlar uchun telegram:"
                        }

                        Link {
                            sx {
                                marginLeft = 12.px
                                fontSize = 18.px
                            }
                            href = ""
                            +""
                        }
                    }
                }
            }
        }
    }
}